import * as Sentry from '@sentry/react';
import type { MetricType } from 'web-vitals';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

/**
 * Инициализация Sentry. Без `VITE_SENTRY_DSN` — полный no-op,
 * чтобы dev и тесты не слали события никуда.
 */
export function initSentry() {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Browser tracing + session replay только в проде: в dev они шумят.
    integrations: import.meta.env.PROD
      ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
      : [],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
  });
}

export function isSentryEnabled() {
  return Boolean(dsn);
}

/** Проставить/сбросить пользователя после логина и logout. */
export function setSentryUser(userId: string | null) {
  if (!dsn) return;
  Sentry.setUser(userId ? { id: userId } : null);
}

/** Отправка Web Vitals как measurement-ов Sentry (см. reportWebVitals). */
export function reportWebVitalToSentry(metric: MetricType) {
  if (!dsn) return;
  Sentry.setMeasurement(metric.name, metric.value, 'millisecond');
  Sentry.addBreadcrumb({
    category: 'web-vitals',
    level: metric.rating === 'good' ? 'info' : 'warning',
    message: `${metric.name}: ${Math.round(metric.value)} (${metric.rating})`,
  });
}

export { Sentry };
